module.exports = __webpack_public_path__ + "static/media/check2.c1f1e1df.mp3";